// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  divisi_code: yup.string().label("Divisi code").required(),
  divisi_name: yup.string().label("Divisi name").required()
})